import { render, staticRenderFns } from "./RestaurantsAdmin.vue?vue&type=template&id=91940bfa"
import script from "./RestaurantsAdmin.vue?vue&type=script&lang=js"
export * from "./RestaurantsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports